import { Observable, of, defer } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';

const keys = [
  'APM_CONSTRUCTION_PROJECT_ADD_NEW', 'APM_CONSTRUCTION_EXC_PROJECT_NEW',
  'APM_LEASE_CONTRACT_ADD_NEW', 'APM_EXP_LEASE_CONTRACT_ADD_NEW',
  'APM_EXPLORATION_ENTRUST_CONTRACT', 'APM_EXCAVATE_ENTRUST_CONTRACT'
];

/** 仅在指定流程的发起/同意接口成功后通知；短信结果不弹提示，不改变已成功的审批结果。 */
export function afterWorkflowApproval(
  url: string, request: any, result: any, prefix: string,
  notify: (body: any) => Observable<any>
): Observable<any> {
  const start = url === prefix + 'activitiRunTime/startPIWithIdAndVar';
  const pass = url === prefix + 'activitiRunTime/passTaskByTaskId';
  const businessKey = request && request.businessKey;
  const key = typeof businessKey === 'string' ? businessKey.split(':')[0] : '';
  if ((!start && !pass) || !result || result.code != 200 || keys.indexOf(key) < 0
    || (pass && !request.taskId)) { return of(result); }
  return defer(() => notify({ businessKey: businessKey, taskId: pass ? request.taskId : '' })).pipe(
    timeout(10000),
    map(() => result),
    catchError(() => of(result))
  );
}
